/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplatePushToEnvResponse
 */
export interface TemplatePushToEnvResponse {
    /**
     * ID of the created (or updated) template on the target environment.
     * @type {string}
     * @memberof TemplatePushToEnvResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplatePushToEnvResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplatePushToEnvResponse
     */
    templateCanonicalId?: string;
}

/**
 * Check if a given object implements the TemplatePushToEnvResponse interface.
 */
export function instanceOfTemplatePushToEnvResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TemplatePushToEnvResponseFromJSON(json: any): TemplatePushToEnvResponse {
    return TemplatePushToEnvResponseFromJSONTyped(json, false);
}

export function TemplatePushToEnvResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplatePushToEnvResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'templateCanonicalId': !exists(json, 'templateCanonicalId') ? undefined : json['templateCanonicalId'],
    };
}

export function TemplatePushToEnvResponseToJSON(value?: TemplatePushToEnvResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'templateCanonicalId': value.templateCanonicalId,
    };
}

